.root {
  min-width: 12rem;
}
